module.exports = __webpack_public_path__ + "static/media/love.87dc2128.svg";